import { Avatar, Box, ListItemText } from '@mui/material';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Award, User } from './Types/Types';

interface Props {
    user: User|null
}

function BuddiesConnect(prop : Props) {
    const [ navigateForward, setNavigateForward ] = useState(false);
    const [ initial, setInitial ] = useState(false);

    const params = useParams();

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (!initial) {
            setInitial(true);
        }
    }, []);

    const getAwardIcon = (icon : string) => {
        return process.env.PUBLIC_URL + '/awards/' + icon;
    }

    useEffect(() => {
        if (initial) {
            const { connectUserId } = params;
            if (connectUserId) {
                axios.post<{buddies: User[], awards: Award[]}>('/connect/' + connectUserId, {}).then(res => {
                    const body = res.data ?? [];
                    const buddies = body.buddies ?? [];
                    const awards = body.awards ?? [];

                    localStorage.setItem('buddies', JSON.stringify(buddies));
                    if (res.status === 208) {
                        enqueueSnackbar(
                            <Box sx={{ display: 'flex' }}>
                            <ListItemText
                                primary={'Es hobs ench scho amoi g\'sechn!'}
                                secondary={'I saufat no mehra! An bestn mitnonn'}
                            />
                            </Box>, { variant: "warning", autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'center' } });
                    } else {
                        awards.forEach((award : Award) => {
                            enqueueSnackbar(
                              <Box sx={{ display: 'flex' }}>
                                <Avatar src={getAwardIcon(award.image)} sx={{ alignSelf: 'center', marginRight: 2 }}/>
                                <ListItemText
                                  primary={award.name}
                                  secondary={award.description}
                                />
                              </Box>, { variant: "success", autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'center' } });
                          });

                        enqueueSnackbar(
                            <Box sx={{ display: 'flex' }}>
                            <ListItemText
                                primary={'Scho wieda oan g`sechn'}
                                secondary={'Dea Hund kennt fü leid'}
                            />
                            </Box>, { variant: "success", autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'center' } });
                    }
                    setNavigateForward(true);
                }).catch(err => {
                    enqueueSnackbar(
                        <Box sx={{ display: 'flex' }}>
                        <ListItemText
                            primary={"Nope, des wiascht nix"}
                            secondary={"Ois loss ma's a nit durchgea"}
                        />
                        </Box>, { variant: "error", autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'center' } });

                    setNavigateForward(true);
                });
            } else {
                setNavigateForward(true);
            }
        }
    }, [initial]);

    return (
        <React.Fragment>
            {navigateForward
                ? <Navigate to={"/buddies"}/>
                : <Box flexGrow={1}>
                    <img src={process.env.PUBLIC_URL + '/rescue-1.gif'} style={{ height: '85%', maxWidth: '100%', opacity: 1, objectFit: 'scale-down' }}/>
                </Box>
            }
        </React.Fragment>
    );
}

export default BuddiesConnect;